
import {onboarding as $onboarding} from 'stores/chats'
import $store from 'stores/global'
import $profile from 'stores/profile'
import {get_store} from 'stores/files'
import {SAMPLE_CONTENT} from 'consts/ftypes'
import $companies from 'stores/companies'
import AIChat from 'components/ai-chat'
import CloseModal from './close-modal.vue'
import Steps from './steps.vue'
import {ref} from 'vue'

export default {
  components: {AIChat, CloseModal, Steps},
  setup() {
    return {
      steps_ref: ref()
    }
  },
  data(){
    return {
      chat: undefined,
    }
  },
  computed: {
    history(){
      return this.chat.history.toSpliced(0, 1)
    },
    generating() {
      return this.chat.generating
    },
    steps(){
      return !!this.steps_ref?.open
    },
    title() {
      return `${this.$store.brand_name} Onboarding Chat`
    }
  },
  watch: {
    chat() {
      this.$nextTick(() => this.$refs.chat.focus())
    }
  },
  async mounted() {
    await $onboarding.load()
    let onboarding = $store.onboarding
    
    if (onboarding) {
      try {
        const chat = $onboarding.getChat(onboarding.chat_id)
        await chat.load()
        this.chat = chat
        return
      }
      catch(err) {
        // onboarding might be already removed on server/from db
        onboarding = undefined
      }
    }
    
    const chat = await $onboarding.newChat({text: 'Genrate Onboarding Chat'}, 'onboarding_v2')
    await chat.load()
    this.chat = chat

    await $store.setOnboarding({chat_id: this.chat.id, completed: false})
  },
  beforeUnmount() {
    if (this.chat) {
      this.chat.abortTasksListener()
    }
  },
  methods: {
    async onChat(params) {
      await this.chat.doChat(params)
    },
    onStop() {
      this.chat.stopChat()
    },
    onClose(){
      this.$refs.close.open()
    },
    async onCompleted(info){
      if (info['first_name'] || info['last_name']) {
        $profile.first_name = info['first_name']
        $profile.last_name = info['last_name']
      }

      if (info['title']) {
        $profile.title = info['title']
      }

      if (info['company']) {
        $profile.company_name = info['company']
      }

      if (info['shared_company_id']) {
        $profile.shared_company_id = info['shared_company_id']
      }

      if (info['bio']) {
        $profile.bio = info['bio']
      }

      if (info['offering']) {
        $profile.offering = info['offering']
      }

      if (info['sample_posts']?.length) {
        const posts = info['sample_posts']
        const fstore = get_store(SAMPLE_CONTENT.type, $profile.id)
        await fstore.load()
    
        const files_ids = fstore.files.map(x => x.id)
        for (const id of files_ids) {
          await fstore.delete(id)
        }

        for (const post of posts) {
          await fstore.addSamplePost(post)
        }
      }

      if (info['companies_to_follow']?.length) {
        const promises = info['companies_to_follow'].map(async ({company_name, linkedin_id, sh_company_id}) => {
          try {
            await $companies.newCompany({
              company_name,
              linkedin_id,
              shared_company_id: sh_company_id
            })
          }
          catch(err) {
            if (err.http_code !== 409) throw err
          }
        })
        await Promise.all(promises)
      }

      await $profile.save()
      await $store.setOnboarding({chat_id: this.chat.id, completed: true})
      $store.goToChats()
    },
    handleResize(){
      if (this.completed) {
        this.$refs.chat?.scrollToEnd()
      }
    }
  }
}
